import React from "react";

const NoItemsFound = () => {
  return (
    <div className="mobile-search-inner">
      <div className="mobile-search-subinner">
        <img
          alt=""
          role="presentation"
          src="https://www.ubereats.com/_static/f601b8be1064c30a.svg"
          className="n6 n7"
        ></img>
        <div data-testid="reset-search-title" className="fb hs fd hv oa">
          We didn't find a match
        </div>
        <p>Try searching for something else instead</p>
        {/* <button className="back-search-btn">
          <div className="c6 c7 c8 c9 b1">Back to store</div>
        </button> */}
      </div>
    </div>
  );
};

export default NoItemsFound;
